module.exports = __webpack_public_path__ + "static/media/french.eca99fe6.svg";